import Login from '../Components/login';

const LogIn = () => {
  return <Login />;
};
export default LogIn;
